import { useSyncExternalStore } from 'react';

/** Color theme chosen by the user; `system` follows the OS setting. */
export type ThemePreference = 'system' | 'light' | 'dark';

const KEY = 'swarm.theme';
const listeners = new Set<() => void>();

function read(): ThemePreference {
  try {
    const value = localStorage.getItem(KEY);
    return value === 'light' || value === 'dark' ? value : 'system';
  } catch {
    return 'system';
  }
}

/** Sets `data-theme` on <html>; without it the tokens follow the system. */
export function applyTheme(preference: ThemePreference = read()) {
  const root = document.documentElement;
  if (preference === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', preference);
}

export function setTheme(preference: ThemePreference) {
  try {
    if (preference === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, preference);
  } catch {
    // Private mode: the choice lasts for this page only.
  }
  applyTheme(preference);
  listeners.forEach((l) => l());
}

export function useThemePreference(): ThemePreference {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    read,
    () => 'system',
  );
}
